import React, { useState } from 'react';
import { Grid, TextField, MenuItem, Card } from "@mui/material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerList } from '../../redux/actions/getCustomerListAction';
import { useEffect } from 'react';
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from 'antd';
import { makeStyles } from "@mui/styles";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Autocomplete from "@mui/lab/Autocomplete";
import {
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import { Alert } from "reactstrap";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { updateFlagsTwoFa } from '../../redux/actions/TwoFactorFlagsUpdateAction';
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { getCustomerIdAndNameList } from '../../redux/actions/getCustomerIdAndNameListAction';
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const TwoFaAuthentication = () => {

    const classes = useStyles();

    const [customerId, setcustomerId] = useState('');
    const [userRole, setuserRole] = useState('');
    const [customerName, setcustomerName] = useState('');
    const [customerListDataTable, setcustomerListDataTable] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const [editModalOpen, seteditModalOpen] = useState(false);
    const [twoFMobileOtp, settwoFMobileOtp] = useState('');
    const [twoFEmailOtp, settwoFEmailOtp] = useState('');
    const [twoFGoogleOtp, settwoFGoogleOtp] = useState('');

    const [updateCustomerId, setupdateCustomerId] = useState('');
    const [editset, seteditset] = useState(false);
    const [editResp, seteditResp] = useState('');
    const [openEditResp, setopenEditResp] = useState(false);

    const [isLoading, setisLoading] = useState(false);

    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const flagsUpdatedRes = useSelector(({ flagsupdatedtwofa }) => flagsupdatedtwofa);
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const getWalletRolesRes = useSelector(({ walletAcRequired }) => walletAcRequired);
    const getCustomerListRes = useSelector(({ getCustomerList }) => getCustomerList);
    var authToken = regenerateTokenRes.data.AuthToken;

    useEffect(() => {
        if (flagsUpdatedRes.data.status) {
            getFlagsUpdatedResponseFunction();
        }
    }, [flagsUpdatedRes.data.status]);

    const getFlagsUpdatedResponseFunction = () => {
        if (editset) {
            if (flagsUpdatedRes.data.status === 'success') {
                seteditResp(flagsUpdatedRes.data.description);
                seteditModalOpen(false);
                setopenEditResp(true);
                searchFunction();
            }
            if (flagsUpdatedRes.data.status === 'failed') {
                seteditResp(flagsUpdatedRes.data.description);
                seteditModalOpen(false);
                if (
                    flagsUpdatedRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    flagsUpdatedRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }

    useEffect(() => {
        if (getCustomerListRes) {
            getCustomerListTable();
        }
    }, [getCustomerListRes.data.status]);

    const getCustomerListTable = () => {
        if (getCustomerListRes) {
            if (getCustomerListRes.data.status === 'Success') {
                setcustomerListDataTable([].concat(getCustomerListRes.data.customerMasterDetailsRequestVOList))
                setisLoading(false);
            }
            if (getCustomerListRes.data.status === 'Failed') {
                if (getCustomerListRes.data.description === 'NOT FOUND') {
                    setcustomerListDataTable([])
                    setisLoading(false);
                }
                if (
                    getCustomerListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getCustomerListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    }


    const handleChange = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'customerId') {
            setcustomerId(value);
        }
        if (name === 'userRole') {
            setuserRole(value);
        }
        if (name === 'customerName') {
            setcustomerName(value);
        }
    }

    const searchFunction = () => {
        setPage(0)
        setisLoading(true);
        const getCustomerListReq = {
            authentication: {
                partnerId: regenerateTokenRes.data.partnerId || ""
            },
            customerRequestVo: {
                customerID: customerId.split("-")[0] || "",
                userRole: userRole === 'Select Role' ? '' : userRole,
                customerName: customerName || ""
            }
        };
        dispatch(getCustomerList(getCustomerListReq, authToken))
    }

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            searchFunction();
        }
    }, [regenerateTokenRes.data.status]);

    const dispatch = useDispatch();

    const [setMobileFlag, setsetMobileFlag] = useState(false);
    const [setEmailFlag, setsetEmailFlag] = useState(false);

    const editCustomerFromTable = (id, mobileTfa, emailTfa,googleTfa, emailVerified, mobileVerified ) => {
        console.log("googleTfasss",googleTfa)
        console.log("mobileTfasss",mobileTfa)

        emailVerified === 'Verified' ? setsetEmailFlag(false) : emailVerified === 'Not Provided' ? setsetEmailFlag(true) : setsetEmailFlag(false)
        mobileVerified === 'Verified' ? setsetMobileFlag(false) : mobileVerified === 'Not Provided' ? setsetMobileFlag(true) : setsetMobileFlag(false);
        settwoFMobileOtp(mobileTfa ? mobileTfa : '');
        settwoFEmailOtp(emailTfa ? emailTfa : '');
        settwoFGoogleOtp(googleTfa ? googleTfa : '');
        setupdateCustomerId(id);
        seteditset(true);
        seteditModalOpen(true);
    }

    const handleClose = () => {
        seteditModalOpen(false);
    }

    const updateDetailsCustomer = () => {
        const updateReq = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: regenerateTokenRes.data.partnerId,
                twoFMobileOtp: twoFMobileOtp,
                twoFEmailOtp: twoFEmailOtp,
                twoFactorGoogle: twoFGoogleOtp,
                customerId: updateCustomerId
            }
        }
        dispatch(updateFlagsTwoFa(updateReq, authToken));
        seteditModalOpen(false);
    }

    const updateChangeFunc = e => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === 'twoFMobileOtp') {
            settwoFMobileOtp(value);
        }
        if (name === 'twoFEmailOtp') {
            settwoFEmailOtp(value);
        }

        if (name === 'twoFGoogleOtp') {
            settwoFGoogleOtp(value);
        }
    }

    const returnIcon = (key, res1, res2) => {
        if (!key) {
            return null;
        }
        if (key === res1) {
            return <Typography title={res1}>
                <Button
                    style={{
                        color: '#fff !important',
                        padding: '0',
                        minWidth: 'max-content',
                        marginLeft: '4px'
                    }}
                >
                    {
                        <CheckCircleIcon
                            className='text-success'
                            style={{
                                fontSize: "20px"
                            }}
                        />
                    }
                </Button>
            </Typography>
        }
        if (key === res2) {
            return <Typography title={res2}>
                <Button
                    style={{
                        color: '#fff !important',
                        padding: '0',
                        minWidth: 'max-content',
                        marginLeft: '4px'
                    }}
                >
                    {
                        <ErrorIcon
                            className='text-warning'
                            style={{
                                fontSize: "20px"
                            }}
                        />
                    }
                </Button>
            </Typography>
        }
    }

    useEffect(() => {
        if (getCustomerIdAndNameListRes.data.status === "Success") {
            //console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
        }
    }, [getCustomerIdAndNameListRes.data.status])

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getCustomerIdAndNameReq = {
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || ""
                },
                actionCustomerMasterRequestVO: {
                    customerNameOrId: ""
                }
            };

            dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);
    const filterOptionsL = (options, { inputValue }) => {
        //console.log(options, inputValue, "optionsss")
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }

    return (
        <>
            <Layout>
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        {/* <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Customer Id"
                                // type="number"
                                variant='standard'
                                fullWidth
                                name="customerId"
                                value={customerId || ""}
                                onChange={handleChange}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getCustomerIdAndNameListRes.data.currencyList || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsL}
                                value={customerId}
                                onChange={handleChange}
                                onInputChange={(event, newInputValue) => {
                                    setcustomerId(newInputValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="Customer ID"
                                        // style={{ marginTop: "3px" }}
                                        // required
                                        type="tel"
                                        fullWidth
                                        {...params}

                                        name="customerId"

                                        variant="standard"
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                margin="dense"
                                id="name"
                                label="Customer Name"
                                variant='standard'
                                type="text"
                                fullWidth
                                name="customerName"
                                value={customerName || ""}
                                onChange={handleChange}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                select
                                margin="dense"
                                id="name"
                                label="Role"
                                type="name"
                                fullWidth
                                variant="standard"
                                name="userRole"
                                value={userRole || ""}
                                onChange={handleChange}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Select Role" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                {getWalletRolesRes.success &&
                                    [].concat(getWalletRolesRes.data.rolesList).map((x) => (
                                        <MenuItem value={x}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={searchFunction}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (<LoadingSpinner />) : (customerListDataTable.length == undefined || customerListDataTable.length == 0) ? (
                    <Card style={{ marginTop: '10px' }}>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText">
                                    Customer List
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    style={{ color: "white" }}

                                    variant="secondary"
                                // style={{ backgroundColor: "#00b9f5", color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card style={{ marginTop: '10px' }}>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Customer List
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Customer Id{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Mobile No.
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Email
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                2FA Mobile OTP
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                2FA Email OTP
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                2FA Google Authenticator
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Role
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {customerListDataTable &&
                                            []
                                                .concat(customerListDataTable)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row) => (
                                                    <TableRow key={row.customerId}>
                                                        <TableCell
                                                            className="themeColor"
                                                            style={{
                                                                marginTop: "1rem",
                                                                cursor: "pointer",
                                                                fontWeight: "600"
                                                            }}
                                                            align="center"
                                                        >
                                                            {row.customerId}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.customerName ? row.customerName : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.mobile ? <p style={{ margin: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                {row.mobile}
                                                                {returnIcon(row.isMobileVerified === 'Verified' ? 'Verified' : row.isMobileVerified === 'Not Provided' ? 'Not Verified' : '', 'Verified', 'Not Verified')}
                                                            </p> : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.customerEmail ? <p style={{ margin: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                {row.customerEmail}
                                                                {returnIcon(row.isEmailVerified === 'Verified' ? 'Verified' : row.isEmailVerified === 'Not Provided' ? 'Non Verified' : '', 'Verified', 'Non Verified')}
                                                            </p> : '-'}
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {row.twoFMobileOTP ? row.twoFMobileOTP : '-'}
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {row.twoFEmailOTP ? row.twoFEmailOTP : '-'}
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                            {row.twoFactorGoogle ? row.twoFactorGoogle : '-'}
                                                        </TableCell>
                                                        <TableCell align="center">{row.userRole ? row.userRole : '-'}</TableCell>

                                                        <TableCell align="center">
                                                            <Tooltip title="Edit">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        editCustomerFromTable(
                                                                            row.customerId,
                                                                            row.twoFMobileOTP,
                                                                            row.twoFEmailOTP,
                                                                            row.twoFactorGoogle,
                                                                            row.isEmailVerified,
                                                                            row.isMobileVerified
                                                                        )
                                                                    }
                                                                >
                                                                    {
                                                                        <EditIcon
                                                                            style={{
                                                                                color: "#fff",
                                                                                fontSize: "20px"
                                                                            }}
                                                                        />
                                                                    }
                                                                </CustomButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={customerListDataTable.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}
                <div>
                    <Dialog open={editModalOpen} onClose={handleClose} >
                        <DialogTitle>Edit Customer</DialogTitle>
                        <DialogContent style={{ width: '500px' }}>
                            <TextField
                                select
                                disabled={setMobileFlag} //need to check api
                                margin="dense"
                                variant='standard'
                                label="Two Factor Mobile OTP Allowed"
                                type="name"
                                name="twoFMobileOtp"
                                fullWidth={true}
                                value={twoFMobileOtp || ""}
                                onChange={updateChangeFunc}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Y">Y</MenuItem>
                                <MenuItem value="N">N</MenuItem>
                            </TextField>

                            <TextField
                                select
                                margin="dense"
                                disabled={setEmailFlag}
                                variant='standard'

                                label="Two Factor Email OTP Allowed"
                                type="name"
                                fullWidth={true}
                                name="twoFEmailOtp"
                                value={twoFEmailOtp || ""}
                                onChange={updateChangeFunc}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Y">Y</MenuItem>
                                <MenuItem value="N">N</MenuItem>
                            </TextField>

                             <TextField
                                select
                                margin="dense"
                                // disabled={setEmailFlag}
                                variant='standard'

                                label="2FA Google Authenticator"
                                type="name"
                                fullWidth={true}
                                name="twoFGoogleOtp"
                                value={twoFGoogleOtp || ""}
                                onChange={updateChangeFunc}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            >
                                <MenuItem value="Y">Y</MenuItem>
                                <MenuItem value="N">N</MenuItem>
                            </TextField> 

                       

                            {/* <TextField
                                margin="dense"
                                id="name"
                                label="Customer Id"
                                type="name"
                                fullWidth
                                variant="standard"
                                value={updateCustomerId || ""}
                                name="customerId"
                                onChange={updateChangeFunc}
                                disabled
                            /> */}

                        </DialogContent>
                        <DialogActions>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </CustomButton>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={updateDetailsCustomer}
                            >
                                Save
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            </Layout>
            {flagsUpdatedRes.data.status == "success" && (
                <div>
                    <Dialog open={openEditResp} onClose={() => setopenEditResp(false)}>
                        <DialogContent
                            className="text-center "
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editResp}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    // backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={() => setopenEditResp(false)}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
            {flagsUpdatedRes.data.status == "failed" && (
                <div>
                    <Dialog open={openEditResp} onClose={() => setopenEditResp(false)}>
                        <DialogContent
                            className="text-center "
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {editResp}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    // backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={() => setopenEditResp(false)}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default TwoFaAuthentication